import LoadingOverlay from "Components/Basic/LoadingOverlay";
import ScheduleInput from "Components/Input/newSchedule/ScheduleInput";
import useGetDataSet from "api/dataSet/getDataSet";
import React, { useMemo } from "react";
import { toast } from "react-hot-toast";

type Props = {
  projectId: string;
  dataSetId: string;
  editingSchedule: string | null;
  closeModal: () => void;
};

export const ScheduleInputModal = ({
  dataSetId,
  projectId,
  editingSchedule,
  closeModal,
}: Props) => {
  const { data, loading, error } = useGetDataSet({
    dataSetId,
    projectId,
  });

  const dataSet = data?.dataSet;

  const currentSchedule = useMemo(() => {
    if (dataSet?.__typename !== "ScheduledDataSet" || !editingSchedule) return undefined;

    return dataSet?.schedules.find(({ tag }) => {
      return tag === editingSchedule;
    });
  }, [dataSet, editingSchedule]);

  if (!dataSet || dataSet.__typename !== "ScheduledDataSet") return null;

  if (loading) return <LoadingOverlay />;
  if (error) {
    console.error(error);
    toast.error("Could not read data set");
    closeModal();
  }

  return (
    <ScheduleInput
      key={`${dataSet.id}-scheduleInput-edit`}
      dataSet={dataSet}
      startSchedule={currentSchedule}
      onFinished={closeModal}
    />
  );
};
